import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const WaitlistTable = ({ list }) => (
  <TableContainer
    component={Paper}
    elevation={0}
    sx={{
      border: "1px solid var(--border-color-light)",
      borderRadius: "var(--radius-lg)",
      overflow: "hidden",
    }}
  >
    <Table size="small">
      <TableHead>
        <TableRow sx={{ backgroundColor: "var(--theme-gray-bg)" }}>
          <TableCell
            sx={{
              fontWeight: 600,
              fontSize: "var(--text-xs)",
              color: "var(--text-color-gray)",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              width: 56,
            }}
          >
            #
          </TableCell>
          <TableCell
            sx={{
              fontWeight: 600,
              fontSize: "var(--text-xs)",
              color: "var(--text-color-gray)",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            Email
          </TableCell>
          <TableCell
            align="right"
            sx={{
              fontWeight: 600,
              fontSize: "var(--text-xs)",
              color: "var(--text-color-gray)",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            Joined
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {list.map((entry, index) => {
          const joinedDate = entry.createdAt?.toDate
            ? entry.createdAt.toDate().toLocaleDateString("en-IN", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })
            : "—";

          return (
            <TableRow
              key={entry.id}
              hover
              sx={{
                "&:last-child td": { border: 0 },
                "&:hover": { backgroundColor: "var(--theme-gray-bg)" },
              }}
            >
              <TableCell
                sx={{
                  fontSize: "var(--text-xs)",
                  color: "var(--text-color-gray)",
                  fontWeight: 500,
                }}
              >
                {index + 1}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: "var(--text-sm)",
                  color: "var(--text-color-primary)",
                  fontWeight: 500,
                }}
              >
                {entry.email ?? "—"}
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  fontSize: "var(--text-xs)",
                  color: "var(--text-color-gray)",
                }}
              >
                {joinedDate}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  </TableContainer>
);

export default WaitlistTable;
